<app-header></app-header>
<ion-content
  data-cy="list-update-content"
  class="gray-content-bg"
  *ngIf="(listUpdatesViewModel$ | async) as listUpdatesViewModel"
>
  <!-- Desktop Page Header -->
  <div data-cy="list-updates-header" class="support-center-header">
    <ion-grid [fixed]="true">
      <!-- Breadcrumbs -->
      <ion-row
        *ngIf=" platformService.platformEnum.desktop === platformService.platformType &&
      (listUpdatesFlag$ | async)"
        class="breadcrumbs-section"
      >
        <ion-col size="8">
          <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        </ion-col>
        <ion-col size="4">
          <div class="interaction-icons">
            <ion-label
              (click)="handleDownload(listUpdatesViewModel.productConversionContainers)"
            >
              <ion-icon name="download-outline"></ion-icon>
              {{ 'i18n.common.download' | translate }}
            </ion-label>
            <ion-label
              (click)="handlePrint(listUpdatesViewModel.productConversionContainers)"
            >
              <ion-icon name="print-outline"></ion-icon>
              {{ 'i18n.common.print' | translate }}
            </ion-label>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col> </ion-col>
      </ion-row>
      <!-- Title -->
      <ion-row>
        <ion-col
          [size]="platformService.platformEnum.tablet === platformService.platformType ? 9 : 12"
        >
          <div class="list-updates-title-container">
            <div>
              <h3
                [class.mobile]="platformService.platformEnum.mobile === platformService.platformType"
              >
                {{'i18n.pageTitles.listUpdates' | translate | uppercase}}
              </h3>
            </div>
            <div
              *ngIf="
             platformService.platformEnum.mobile === platformService.platformType &&
              (listUpdatesFlag$ | async)"
              data-cy="update-list-title-ellipsis-section"
              class="ellipsis-container"
            >
              <ion-icon
                data-cy="update-list-title-ellipsis-icon"
                name="ellipsis-vertical"
                (click)="openListUpdatesEllipsisMenu(listUpdatesViewModel.productConversionContainers)"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
        <ion-col
          size="3"
          *ngIf="platformService.platformEnum.tablet === platformService.platformType && (listUpdatesFlag$ | async)"
        >
          <div
            class="interaction-icons"
            [class.tablet]="platformService.platformEnum.tablet === platformService.platformType"
          >
            <ion-label
              (click)="handleDownload(listUpdatesViewModel.productConversionContainers)"
            >
              <ion-icon name="download-outline"></ion-icon>
              {{ 'i18n.common.download' | translate }}
            </ion-label>
            <ion-label
              (click)="handlePrint(listUpdatesViewModel.productConversionContainers)"
            >
              <ion-icon name="print-outline"></ion-icon>
              {{ 'i18n.common.print' | translate }}
            </ion-label>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="updated-products-count">
            {{(listUpdatesViewModel?.updateCount)}}&nbsp;{{('i18n.lists.updatedProductsOnList'
            | translate)}}
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <ion-grid [fixed]="true">
    <app-product-conversion-container
      [platform]="platformService?.platformType"
      [isOnline]="listUpdatesViewModel?.isOnline"
      [productConversionContainers]="listUpdatesViewModel?.productConversionContainers"
      [showAcceptDeclineButtons]="false"
      [originalProductTitle]="'i18n.lists.previousProduct'"
      [pricingDisabled]="listUpdatesViewModel?.pricingDisabled"
      (changeQuantityEmitter)="changeQuantityHandler($event)"
      (productImageClickEmitter)="handleProductImageClick($event)"
      (compareClickEmitter)="handleCompareClick($event)"
    >
    </app-product-conversion-container>
  </ion-grid>

  <app-footer></app-footer>
</ion-content>
